'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWhitelistedUtmKeys = getWhitelistedUtmKeys;
exports.toLowerCaseKeys = toLowerCaseKeys;
exports.removeNonHubsParams = removeNonHubsParams;
exports.getHubsKeyMappedToUtm = getHubsKeyMappedToUtm;
exports.mergeFromExp = mergeFromExp;
exports.transformParamArraysToValues = transformParamArraysToValues;
exports.maybeSetDocumentReferrer = maybeSetDocumentReferrer;
exports.hubsToUtmData = hubsToUtmData;
exports.additionalHubsData = additionalHubsData;
exports.parseUtmData = parseUtmData;
exports.getOnlyExpParams = getOnlyExpParams;

var _jQuery = require('jQuery');

var _jQuery2 = _interopRequireDefault(_jQuery);

var _immutable = require('immutable');

var _pick = require('hs-lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _omit = require('hs-lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _isArray = require('hs-lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _defaultUtms = require('../constants/defaultUtms');

var _defaultUtms2 = _interopRequireDefault(_defaultUtms);

var _expUtms = require('../constants/expUtms');

var _expUtms2 = _interopRequireDefault(_expUtms);

var _mappedUtmToHubs = require('../constants/mappedUtmToHubs');

var _mappedUtmToHubs2 = _interopRequireDefault(_mappedUtmToHubs);

var _Analytics = require('../utils/Analytics');

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cachedKeys = void 0;
var hubsCachedKeys = void 0;

function getWhitelistedUtmKeys() {
  if (cachedKeys) {
    return cachedKeys;
  }

  var whitelistedKeys = new _immutable.Set();

  // add the rest of the defaults
  _defaultUtms2.default.forEach(function (utmKey) {
    whitelistedKeys = whitelistedKeys.add(utmKey);
  });
  // add alternative exp-* prefixed params that will replace utms
  Object.keys(_expUtms2.default).forEach(function (expKey) {
    whitelistedKeys = whitelistedKeys.add(expKey);
  });

  cachedKeys = whitelistedKeys;
  return cachedKeys;
}

function toLowerCaseKeys(utmData) {
  return Object.keys(utmData).reduce(function (accumulator, curKey) {
    accumulator[curKey.toLowerCase()] = utmData[curKey];
    return accumulator;
  }, {});
}

function removeNonHubsParams(hubsData) {
  return Object.keys(hubsData).reduce(function (accumulator, curKey) {
    if (curKey.substring(0, 5) === 'hubs_') {
      accumulator[curKey.toLowerCase()] = hubsData[curKey];
    }
    return accumulator;
  }, {});
}

function getHubsKeyMappedToUtm() {
  if (hubsCachedKeys) {
    return hubsCachedKeys;
  }

  var whitelistedKeys = new _immutable.Set();

  // add the rest of the defaults
  Object.keys(_mappedUtmToHubs2.default).forEach(function (key) {
    whitelistedKeys = whitelistedKeys.add(key);
  });

  hubsCachedKeys = whitelistedKeys;
  return hubsCachedKeys;
}

function mergeFromExp(utmData) {
  return Object.keys(utmData).reduce(function (accumulator, curKey) {
    var curVal = utmData[curKey];

    if (curKey.indexOf('exp-') === 0) {
      var equivalentKey = _expUtms2.default[curKey];
      accumulator[equivalentKey] = curVal;
    } else {
      if (typeof accumulator[curKey] === 'undefined') {
        accumulator[curKey] = curVal;
      }
    }
    return accumulator;
  }, {});
}

function transformParamArraysToValues(utmData) {
  return Object.keys(utmData).reduce(function (accumulator, curKey) {
    var curVal = utmData[curKey];
    if ((0, _isArray2.default)(curVal)) {
      accumulator[curKey] = curVal[0];
    } else {
      accumulator[curKey] = curVal;
    }
    return accumulator;
  }, {});
}

function maybeSetDocumentReferrer(utmData) {
  var referrer = (0, _Analytics.getReferrer)();

  if (referrer && !utmData.utm_medium && !utmData.utm_source) {
    utmData.utm_medium = 'referral';
    utmData.utm_source = referrer;
  }

  return utmData;
}

function prepareHubsParams() {
  var hubsKeyMappedToUtm = getHubsKeyMappedToUtm();
  var firstTouchHubs = {};

  // first-touch params tend to be stored in cookies
  // but we look for the original utm_ key in the cookies, so to keep the original value, if any
  hubsKeyMappedToUtm.forEach(function (key) {
    var utmKey = key.replace('hubs_', 'utm_');
    var value = _jQuery2.default.cookie(utmKey);
    if (value) {
      firstTouchHubs[key] = value;
    }
  });
  return { hubsKeyMappedToUtm: hubsKeyMappedToUtm, firstTouchHubs: firstTouchHubs };
}

function hubsToUtmData(hubsData) {
  var _prepareHubsParams = prepareHubsParams(),
      hubsKeyMappedToUtm = _prepareHubsParams.hubsKeyMappedToUtm,
      firstTouchHubs = _prepareHubsParams.firstTouchHubs;

  var normalizeData = (0, _redux.compose)(toLowerCaseKeys, transformParamArraysToValues);
  hubsData = normalizeData(hubsData);

  // only the hubs param to be mapped to an utm param will be considered
  return Object.assign(firstTouchHubs, (0, _pick2.default)(hubsData, hubsKeyMappedToUtm.toJS()));
}

function additionalHubsData(hubsData) {
  var _prepareHubsParams2 = prepareHubsParams(),
      hubsKeyMappedToUtm = _prepareHubsParams2.hubsKeyMappedToUtm,
      firstTouchHubs = _prepareHubsParams2.firstTouchHubs;

  var normalizeData = (0, _redux.compose)(removeNonHubsParams, toLowerCaseKeys, transformParamArraysToValues);
  hubsData = normalizeData(hubsData);

  // here I want all hubs_* params except for the one that should be mapped to an utm param
  return Object.assign(firstTouchHubs, (0, _omit2.default)(hubsData, hubsKeyMappedToUtm.toJS()));
}

function parseUtmData(utmData) {
  var whitelistedKeys = getWhitelistedUtmKeys();
  var firstTouchUtms = {};

  // first-touch params tend to be stored in cookies
  whitelistedKeys.forEach(function (key) {
    var value = _jQuery2.default.cookie(key);
    if (value) {
      firstTouchUtms[key] = value;
    }
  });

  // Duplicate utm query param entries will show up
  // as an array in the utmData object because of the way
  // react-router interprets location.query data. This function
  // will detect multiple utm entries and pick only the first one.
  utmData = toLowerCaseKeys(utmData);
  utmData = transformParamArraysToValues(utmData);

  var cleanedUtmData = (0, _pick2.default)(utmData, whitelistedKeys.toJS());
  return Object.assign(firstTouchUtms, cleanedUtmData);
}

function getOnlyExpParams(utmData) {
  return (0, _pick2.default)(utmData, Object.keys(_expUtms2.default));
}